/* 绑定结果 */
<template>
  <div class="binding-result">
    <!-- 头部 -->
    <headerTop title="绑定结果" :isCustomeBack="true" @customeBackEvent="customeBack"></headerTop>
    <div class="content">
      <!-- 图标 -->
      <p class="icon">
        <span v-if="tipsChage" class="iconfont iconchenggong"></span>
        <span v-else class="iconfont iconshibai1"></span>
      </p>
      <!-- 文字 -->
      <p class="text">
        <span>绑定完成</span>
      </p>
      <!-- 失败提示词 -->
      <p class="tips">
        <span v-if="tipsChage==false">姓名、手机号、银行、银行卡号需匹配</span>
      </p>
    </div>
  </div>
</template>

<script>
import accountApi from "@/api/accountApi";
import headerTop from "@/components/common/headerTop.vue";

export default {
  data() {
    return {
      tipsChage: true
    };
  },
  components: {
    headerTop
  },
  methods: {
    customeBack() {
      this.$router.push({ name: "myUserHome" });
    }
  }
};
</script>

<style lang="less" scoped>
.binding-result {
  .content {
    padding-top: 75px;

    text-align: center;
    .icon {
      .iconchenggong {
        font-size: 40px;
        color: #2eac58;
      }
      .iconshibai1 {
        font-size: 40px;
        color: #ea2c2c;
      }
    }
    .text {
      font-size: 18px;
      color: #1d1d1d;
      font-weight: 700;
      margin-top: 10px;
    }
    .tips {
      font-size: 14px;
      color: #999999;
      margin-top: 20px;
    }
  }
}
</style>
